export default __webpack_public_path__ + "static/media/goopter-hotel-service-automation-robots-features.fcf51784.png";